import { useEffect } from 'react';

// Umožnění použití kalkulace v edit módu (produkty nám pošle BE, protože je mažeme po odeslání)
export const useEditMode = (
    savePickedPackageProductsToStorage,
    isLocalStorageClear,
    cartItemId,
    packageId,
    setPickedProducts,
    pickedProductsApi,
    phaseSteps
) => {
    useEffect(() => {
        const isEditMode = !!cartItemId;

        if (!isEditMode) {
            return;
        }

        const shouldInitProductsFromApi =
            pickedProductsApi && pickedProductsApi.length > 0 && isLocalStorageClear(cartItemId, null, [packageId]);

        if (shouldInitProductsFromApi) {
            savePickedPackageProductsToStorage(cartItemId, packageId, pickedProductsApi, phaseSteps, setPickedProducts);
        }
    }, [cartItemId, packageId, pickedProductsApi, phaseSteps]);
};
